import { CircuitFormData } from '@/types/circuits/CircuitFormData';
import { useMemo } from 'react';

export const useIsCircuitDayEmpty = (
  circuitDay: CircuitFormData['circuitDays'][number],
): boolean => {
  return useMemo(() => {
    if (circuitDay?.stepTitle && circuitDay.stepTitle.length > 0) {
      return false;
    }

    if (circuitDay?.description && circuitDay.description.length > 0) {
      return false;
    }

    if (circuitDay?.images && circuitDay.images.length > 0) {
      return false;
    }

    return !circuitDay?.steps.some((step) => {
      if (
        step.transport?.standardBenefit ||
        step.transport?.optionalBenefits.length > 0
      ) {
        return true;
      }

      if (
        step.meals?.standardBenefit ||
        step.meals?.optionalBenefits.length > 0
      ) {
        return true;
      }

      if (
        step.activities?.standardBenefit ||
        step.activities?.optionalBenefits.length > 0
      ) {
        return true;
      }

      if (
        step.accommodations?.standardBenefit ||
        step.accommodations?.optionalBenefits.length > 0
      ) {
        return true;
      }

      return false;
    });
  }, [
    circuitDay?.description,
    circuitDay?.images,
    circuitDay?.stepTitle,
    circuitDay?.steps,
  ]);
};
